import { experimentsEnum } from './experimentsEnum';
import { getTestVariation, TEST_VARIATION_B } from './index';

const isInSearchBarHighlightTextTest = (abTests) => {
    const testVariation = getTestVariation(abTests, experimentsEnum.CAT_LISTINGS_SEARCH_BAR_CHANGE_HIGHLIGHT_TEXT);

    return testVariation === TEST_VARIATION_B;
};

export default isInSearchBarHighlightTextTest;
